import { Col, Image } from 'antd';
import React, { memo, useCallback } from 'react';
import {
  OverLay,
  TitleCarousel,
  ContentCarousel,
  CarouselContentWrapper,
  CarouselRow,
  CarouselButton,
} from './styled';

const contentStyle = {
  height: 'auto',
  width: '100%',
  maxHeight: 750,
};

const HomeCarouselContent = memo(
  ({ imagePath, actionText1, actionText2, actionText3 }) => {
    // handle bottom button
    const onButtonActionHandle = useCallback(() => {}, []);

    return (
      <CarouselContentWrapper>
        <Image style={contentStyle} src={imagePath} />
        <OverLay>
          <CarouselRow>
            <Col span={16} offset={4}>
              {actionText1 && <TitleCarousel>{actionText1}</TitleCarousel>}
              {actionText2 && (
                <TitleCarousel marginbt>{actionText2}</TitleCarousel>
              )}
              {actionText3 && <ContentCarousel>{actionText3}</ContentCarousel>}
              <CarouselButton size="large" type="primary">
                See More
              </CarouselButton>
            </Col>
          </CarouselRow>
        </OverLay>
      </CarouselContentWrapper>
    );
  }
);

export default HomeCarouselContent;
